const dataStorage = {
    theme: 'dark',
    deviceId: '',
    session: {},
    phone: '',
    accountStatus: '',
    timeSendOTP: {},
    auth: {},
    config: {}
}
export default dataStorage